import { useState } from "react";
import type { ReactElement } from "react";
import { Modal, ModalFuss } from "@kundeninfo/ui";
import { Schalter } from "@kundeninfo/ui/me-design";
import { SUCCESSION_TEXT as T } from "./texts.js";

/**
 * Die Rückfrage vor dem Kopieren (Spec „Kopieren und Nachfolge“): Sie erklärt beide Wege — Kopie mit neuer Nummer oder
 * „Neue Version“ derselben Nummer — und trägt den Schalter „Das neue Angebot ersetzt ‹Nr›“ (aus). Eine Frage mit einem
 * Eingabeelement, deshalb `Modal frage` (klein, mittig, gestapelt) statt `useBestaetigung`. „Kopieren“ IST die
 * Bestätigung; solange der Weg läuft, sind beide Ausgänge gesperrt. Schließen tut der Rahmen, wenn der Weg zurück ist.
 */
export function CopyOfferDialog(p: {
  quelleNummer: string;
  onKopieren: (replacesSource: boolean) => Promise<void>;
  onAbbrechen: () => void;
}): ReactElement {
  const [replacesSource, setReplacesSource] = useState(false);
  const [running, setRunning] = useState(false);
  async function submit(): Promise<void> {
    setRunning(true);
    try { await p.onKopieren(replacesSource); } finally { setRunning(false); }
  }
  return (
    <Modal frage titel={T.copyTitle} onAbbrechen={p.onAbbrechen} abbrechenGesperrt={running}>
      <p>{T.copyText}</p>
      <Schalter id="offer-copy-replaces" name="offer-copy-replaces" beschriftung={T.copyReplaces(p.quelleNummer)}
        an={replacesSource} gesperrt={running} onGeaendert={(d) => setReplacesSource(d.an)} />
      <ModalFuss speichernText={T.copyAction} speichernGesperrt={running} abbrechenGesperrt={running}
        onSpeichern={() => { void submit(); }} onAbbrechen={p.onAbbrechen} />
    </Modal>
  );
}
